import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import Position from './Position';
/** @type {any} */
const PinTR = forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(Position, Object.assign({ position: "absolute", ref: ref, right: 0, top: 0 }, props, { children: children })));
});
export default PinTR;
